export const zhHK = {
  login: '登入',
  logout: '登出',
}
